<template>

  <div>
    <InputSelect label="Mode" v-model="mode" :options="[
      { value: 'AUTO', label: 'Auto' },
      { value: 'SINGLE', label: 'Single JPEGs' },
      { value: 'GRID', label: 'Gridded JPEGs' },
      { value: 'WEBVTT', label: 'WebVTT Index' },
      { value: 'BIF', label: 'BIF' }
    ]" :help="apiDocs('clpp.ThumbnailsConfiguration#mode')"/>

    <InputTextField label='URL'
                           :null2undefined="true"
                           :help="apiDocs('clpp.ThumbnailsConfiguration#url')"
                           v-model="config.url"/>

    <FlexRow>
      <FlexItem><InputTextField label='Template Key' :null2undefined="true" :help="apiDocs('clpp.ThumbnailsConfiguration#templateKey')" v-model="config.templateKey"/></FlexItem>
      <FlexItem><InputTextField label='Duration' type="number" :null2undefined="true" :help="apiDocs('clpp.ThumbnailsConfiguration#duration')" v-model="config.duration"/></FlexItem>
    </FlexRow>

    <FlexRow>
      <FlexItem><InputTextField label='Grid Rows' type="number" v-model="width"/></FlexItem>
      <FlexItem><InputTextField label='Grid Columns' type="number" v-model="height"/></FlexItem>
    </FlexRow>
    <ApiDescription api="clpp.ThumbnailsConfiguration#gridSize"/>

    <div>
      <h3 class="config-subheader">Preloading Thumbs</h3>
      <ApiDescription api="clpp.ThumbnailsConfiguration#preload"/>
      <div style="display: flex; align-items: center" v-for="(p, index) in this.preloads" v-bind:key="index">
        <div style="flex: 0 1 auto;">
          <InputTextField label='Step' type="number" style="max-width: 100px; padding-right: 16px;" v-model="p.step"/>
        </div>
        <div style="flex: 1 1 auto; ">
          <InputCheckbox label='Load While Buffering' v-model="p.preloadWhileBuffering"/>
        </div>
        <div style="flex: 0 0 auto;">
          <button class="button" style="margin-right: 0.5rem" @click="removePreload(index)">
            <i class="icon">remove_circle_outline</i></button>
          <button class="button" @click="addPreload(index + 1)">
            <i class="icon">add_circle_outline</i>
          </button>
        </div>
      </div>
      <div style="display: flex" v-if="this.preloads.length === 0">
        <div style="flex: 1 1 auto;"></div>
        <div style="flex: 0 0 auto; "><button class="button" @click="addPreload(0)">
          <i class="icon">add_circle_outline</i></button></div>
      </div>
    </div>
  </div>

</template>

<script>
import ApiDescription from '../../docs/ApiDescription';
import InputSelect from '../../forms/InputSelect';
import InputTextField from '../../forms/InputTextField';
import { Docs } from '../../../utils/docs';
import FlexRow from '../../layout/FlexRow';
import FlexItem from '../../layout/FlexItem';
import InputCheckbox from '../../forms/InputCheckbox';

/*
 * @typedef {{
 *   enabled: (boolean|undefined),
 *   mode: (string|undefined),
 *   duration: (number|undefined),
 *   url: (string|undefined),
 *   templateKey: (string|undefined),
 *   gridSize: (string|undefined),
 *   preload: (Array<(clpp.PreloadConfiguration|number)>|undefined)
 * }}
 */
const EMPTY_THUMB_DATA = {
  enabled: true,
  mode: undefined,
  duration: undefined,
  url: undefined,
  templateKey: undefined,
  gridSize: undefined,
  preload: undefined
};

export default {
  name: 'PlayerConfigThumbnailConfig',
  components: { InputCheckbox, FlexItem, FlexRow, InputTextField, InputSelect, ApiDescription },
  props: ['value'],
  data: function () {
    return {
      config: null,
      width: undefined,
      height: undefined,
      mode: 'AUTO',
      preloads: []
    };
  },
  methods: {
    removePreload (index) {
      if (index >= 0) {
        this.preloads.splice(index, 1);
      }
    },
    addPreload (index) {
      if (index < 0) {
        index = 0;
      }
      this.preloads.splice(index, 0, { step: 0, preloadWhileBuffering: false });
    },
    apiDocs (field) {
      return Docs.getDescription(field);
    },
    emitUpdate () {
      // this.$emit('input', Object.assign({}, this.value, { 'thumbnails': this.config }));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (!newVal || !newVal.thumbnails) {
          this.config = Object.assign({}, EMPTY_THUMB_DATA);
        } else if (newVal && newVal.thumbnails) {
          this.config = Object.assign({}, EMPTY_THUMB_DATA, newVal.thumbnails);
        }

        if (this.config.gridSize) {
          const s = this.config.gridSize.split('x');
          if (s.length === 2) {
            this.width = s[0];
            this.height = s[0];
          }
        }
        if (this.config.mode) {
          this.mode = this.config.mode;
        }
        if (this.config.preload) {
          this.preloads = [];
          this.config.preload.forEach(p => {
            if (typeof p === 'number') {
              this.preloads.push({ step: p, preloadWhileBuffering: false });
            } else {
              this.preloads.push(p);
            }
          });
        }
        this.config.preload = this.preloads;
        this.value.thumbnails = this.config;
      }
    },
    mode: function (nv) {
      if (nv === 'AUTO') {
        this.config.mode = undefined;
      } else {
        this.config.mode = nv;
      }
      this.emitUpdate();
    },
    width: function (nv) {
      if (nv !== undefined && this.height !== undefined) {
        this.config.gridSize = `${nv}x${this.height}`;
      } else {
        this.config.gridSize = undefined;
      }
      this.emitUpdate();
    },
    height: function (nv) {
      if (nv !== undefined && this.width !== undefined) {
        this.config.gridSize = `${this.width}x${nv}`;
      } else {
        this.config.gridSize = undefined;
      }
      this.emitUpdate();
    }
  }
};
</script>
